'use client';

import {
  LuMapPin,
  LuPhone,
  LuMail,
  LuClock,
  LuFacebook,
  LuInstagram,
  LuLinkedin,
} from 'react-icons/lu';
import { FaXTwitter } from 'react-icons/fa6';
import { Separator } from '@/components/ui/separator';

const contactInfo = [
  {
    icon: <LuMapPin className='h-6 w-6' />,
    title: 'Our Location',
    details: 'Malindi, Opposite Mbuzi Wengi',
    color: 'bg-blue-500',
    hoverColor: 'hover:bg-blue-400',
    gradientFrom: 'from-blue-500',
    gradientTo: 'to-blue-600',
  },
  {
    icon: <LuPhone className='h-6 w-6' />,
    title: 'Phone Number',
    details: '+254 756 211 546',
    color: 'bg-green-500',
    hoverColor: 'hover:bg-green-400',
    gradientFrom: 'from-green-500',
    gradientTo: 'to-emerald-600',
  },
  {
    icon: <LuMail className='h-6 w-6' />,
    title: 'Email Address',
    details: 'info@qwetulands.com',
    color: 'bg-orange-500',
    hoverColor: 'hover:bg-orange-400',
    gradientFrom: 'from-orange-500',
    gradientTo: 'to-amber-600',
  },
  {
    icon: <LuClock className='h-6 w-6' />,
    title: 'Working Hours',
    details: 'Mon - Sat: 8:00 AM - 6:00 PM',
    color: 'bg-purple-500',
    hoverColor: 'hover:bg-purple-400',
    gradientFrom: 'from-purple-500',
    gradientTo: 'to-indigo-600',
  },
];

const socialLinks = [
  {
    name: 'Facebook',
    icon: <LuFacebook className='h-5 w-5' />,
    url: 'https://www.facebook.com/Qwetulands?_rdc=1&_rdr#',
    color: 'hover:bg-blue-600',
    hoverText: 'hover:text-blue-300',
  },
  {
    name: 'X (Twitter)',
    icon: <FaXTwitter className='h-5 w-5' />,
    url: 'https://x.com/Qwetulands',
    color: 'hover:bg-black',
    hoverText: 'hover:text-gray-300',
  },
  {
    name: 'LinkedIn',
    icon: <LuLinkedin className='h-5 w-5' />,
    url: 'https://www.linkedin.com/in/joseph-mburu/',
    color: 'hover:bg-blue-700',
    hoverText: 'hover:text-blue-300',
  },
];

export default function ContactInfo() {
  return (
    <div>
      <h2 className='text-3xl font-bold tracking-tight text-white mb-6'>
        <span className='bg-linear-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent'>
          Contact Information
        </span>
      </h2>

      <div className='space-y-4'>
        {contactInfo.map((info, index) => (
          <div
            key={index}
            className='flex items-start p-4 rounded-lg bg-gray-800/50 border border-gray-700 backdrop-blur-xs hover:bg-gray-700/50 transition-all duration-300'
          >
            <div className={`bg-linear-to-br ${info.gradientFrom} ${info.gradientTo} p-3 rounded-lg text-white shrink-0 shadow-lg`}>
              {info.icon}
            </div>
            <div className='ml-4'>
              <h3 className='text-base font-semibold text-white'>
                {info.title}
              </h3>
              <p className='mt-1 text-gray-300'>{info.details}</p>
            </div>
          </div>
        ))}
      </div>

      <Separator className='my-8 bg-gray-700' />

      <div>
        <h3 className='text-xl font-semibold text-white mb-4'>
          <span className='bg-linear-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent'>
            Follow Us
          </span>
        </h3>

        <p className='text-gray-300 mb-4'>
          Stay connected with us on social media for updates, tips, and more
          information about our services.
        </p>

        <div className='flex space-x-3'>
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={`Follow on ${social.name}`}
              className={`p-2 rounded-full bg-gray-700/50 text-gray-300 ${social.color} ${social.hoverText} border border-gray-600 hover:border-gray-500 transition-colors duration-300`}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>

      <Separator className='my-8 bg-gray-700' />

      <div>
        <h3 className='text-xl font-semibold text-white mb-4'>
          <span className='bg-linear-to-r from-emerald-400 to-purple-400 bg-clip-text text-transparent'>
            Need Urgent Help?
          </span>
        </h3>

        <p className='text-gray-300 mb-4'>
          For urgent inquiries, you can reach our customer support team
          directly.
        </p>

        <a
          href='tel:+254756211546'
          className='inline-flex items-center px-6 py-3 border border-transparent rounded-full shadow-xs text-sm font-medium text-white bg-linear-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-blue-500 transition-all duration-300'
        >
          <LuPhone className='mr-2 -ml-1 h-4 w-4' />
          Call Us Now
        </a>
      </div>
    </div>
  );
}
